var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonProvider } from '../../providers/common/common';
var ScannerComponent = /** @class */ (function () {
    function ScannerComponent(comProv) {
        var _this = this;
        this.comProv = comProv;
        this.formats = "'QR_CODE','EAN_13','CODE_39','CODE_128'";
        this.returnText = new EventEmitter();
        this.hasCameras = false;
        this.is_available = true;
        this.disp_caution = false;
        this.os_version = this.comProv.getOsVersion();
        if (!this.comProv.isApp()) {
            if (this.comProv.isIos()) {
                if (Number(this.os_version) < 11) {
                    this.is_available = false;
                }
            }
        }
        setTimeout(function () {
            _this.disp_caution = true;
        }, 3000);
    }
    ScannerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.scannerElment.camerasFound.subscribe(function (devices) {
            _this.hasCameras = true;
            _this.availableDevices = devices;
            _this.setDevice();
        });
        this.scannerElment.permissionResponse.subscribe(function (answer) {
            _this.hasPermission = answer;
        });
    };
    ScannerComponent.prototype.setDevice = function () {
        var camera_no = 0;
        if (this.availableDevices.length > 1) {
            for (var i = 0; i < this.availableDevices.length; i++) {
                if (this.availableDevices[i]['label'].indexOf('back') != -1 || this.availableDevices[i]['label'].indexOf('背面') != -1) {
                    camera_no = i;
                    break;
                }
            }
        }
        this.selectedDevice = this.scannerElment.getDeviceById(this.availableDevices[camera_no]['deviceId']);
    };
    ScannerComponent.prototype.unSetDevice = function () {
        this.selectedDevice = null;
    };
    ScannerComponent.prototype.handleQrCodeResult = function (resultString) {
        console.log('handleQrCodeResult', resultString);
        this.barcode_text = resultString;
        this.returnText.emit(this.barcode_text);
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ScannerComponent.prototype, "formats", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], ScannerComponent.prototype, "returnText", void 0);
    __decorate([
        ViewChild('scanner'),
        __metadata("design:type", Object)
    ], ScannerComponent.prototype, "scannerElment", void 0);
    ScannerComponent = __decorate([
        Component({
            selector: 'scanner',
            templateUrl: 'scanner.html'
        }),
        __metadata("design:paramtypes", [CommonProvider])
    ], ScannerComponent);
    return ScannerComponent;
}());
export { ScannerComponent };
//# sourceMappingURL=scanner.js.map


// WEBPACK FOOTER //
// ./src/components/scanner/scanner.ts.pre-build-optimizer.js